module.exports = __webpack_public_path__ + "img/occupancy-icon.0dc0c87b.svg";